//noinspection ThisExpressionReferencesGlobalObjectJS
/** @suppress {globalThis} */
(this["require"] = require);
